import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LineHeartIcon from 'components/Luxkit/Icons/line/LineHeartIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'

const Container = styled(Group)`
  padding: ${rem(80)} 0;
  margin: ${rem(20)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(80)} ${rem(24)};
    margin: ${rem(20)} ${rem(80)};
  }
`

export default function EmptySavedItems() {
  return (
    <Container gap={16} direction="vertical" horizontalAlign="center">
      <LineHeartIcon size="L" />
      <Group gap={8} direction="vertical" horizontalAlign="center">
        <Heading variant="heading4" align="center">
          You have no saved items
        </Heading>
        <BodyText variant="medium" colour="neutral-three" align="center">
          Search our exclusive hotel offers, explore trip ideas in the Explore
          area or add bookings you've made elsewhere.
        </BodyText>
      </Group>
    </Container>
  )
}
